/**
 * PURPOSE:
 * Storage local del módulo visualizador de vóley en HAYLLIS.
 *
 * ROUTE:
 * src/pages/VolleyballViewer/utils/volleyballViewerStorage.js
 */

const DEVICE_KEY = "hayllis:volleyball-viewer:device-id";
const SESSION_PREFIX = "hayllis:volleyball-viewer:session:";

function randomPart() {
  if (window.crypto?.getRandomValues) {
    const arr = new Uint32Array(2);
    window.crypto.getRandomValues(arr);
    return `${arr[0].toString(16)}${arr[1].toString(16)}`;
  }
  return `${Date.now().toString(16)}${Math.random().toString(16).slice(2)}`;
}

export function getOrCreateViewerDeviceId() {
  const existing = localStorage.getItem(DEVICE_KEY);
  if (existing) return existing;
  const next = `hv-${randomPart()}`;
  localStorage.setItem(DEVICE_KEY, next);
  return next;
}

export function readViewerSession(matchId) {
  try {
    const raw =
      sessionStorage.getItem(`${SESSION_PREFIX}${matchId}`) ||
      localStorage.getItem(`${SESSION_PREFIX}${matchId}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveViewerSession(matchId, session, { remember = false } = {}) {
  const key = `${SESSION_PREFIX}${matchId}`;
  const value = JSON.stringify(session || {});
  sessionStorage.setItem(key, value);
  if (remember) localStorage.setItem(key, value);
}

export function clearViewerSession(matchId) {
  const key = `${SESSION_PREFIX}${matchId}`;
  sessionStorage.removeItem(key);
  localStorage.removeItem(key);
}
